import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { PublicUser } from '../types';

interface AuthState {
  user: PublicUser | null;
  /** Marca que ja existiu uma sessao - evita piscar a tela de login no refresh. */
  hasSession: boolean;
  setUser: (user: PublicUser | null) => void;
  clear: () => void;
}

/**
 * Estado global de autenticacao.
 * A fonte da verdade continua sendo o cookie de sessao + GET /auth/me;
 * a store guarda apenas o usuario para leitura sincrona pela UI.
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      hasSession: false,

      setUser: (user) => set({ user, hasSession: user !== null }),

      clear: () => set({ user: null, hasSession: false }),
    }),
    {
      name: 'crm.auth',
      partialize: (state) => ({ user: state.user, hasSession: state.hasSession }),
    },
  ),
);
